<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="x_panel">
          <h2 class="float-left">Spare Parts Consumption History List</h2>
          <ul class="nav navbar-right panel_toolbox" v-if="!listMode">
            <li>
              <button type="button" class="btn btn-info btn-sm" @click="changeListMode">View Job List <i class="fa fa-eye"></i></button>
            </li>
          </ul>
          <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
          <button v-if="isPermissionExist(PERMISSIONS.SPARE_PARTS_CONSUMPTION_HISTORY_REPORT_PRINT)" @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
            <i class="fa fa-print" v-if="!isPrinting"></i>
            <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
            {{ isPrinting ? 'Printing...' : 'Print' }}
          </button>
          <vue-excel-xlsx
            v-if="isPermissionExist(PERMISSIONS.SPARE_PARTS_CONSUMPTION_HISTORY_REPORT_PRINT)"
            ref="excel"
            :data="excelData"
            :columns="excelHeader"
            :file-name="'Spare Parts Consumption History List'"
            :file-type="'xlsx'"
            :sheet-name="'sheetname'"
            :disabled="isPrinting"
            class="btn btn-primary btn-sm float-right"
          >
            <div
              @click.prevent="handleExportPrint('excel')"
            >
              <i class="fa fa-file-excel-o"></i>
              {{ isPrinting ? 'Preparing...' : 'Excel' }}
            </div>
          </vue-excel-xlsx>
        </div>

        <div class="">
          <div class="x_content ">
            <div class="row" v-if="listMode && jobList">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <select class="form-control" v-model="scheduleInfo.vesselId">
                            <option value="" selected>Select Vessel</option>
                            <option v-for="(row, key) in vessels" :value="row?.id">{{row?.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <select v-model="scheduleInfo.department_id" name="department_id" class="form-control" @change="getMainComponent(scheduleInfo.department_id)">
                            <option value selected>Select department</option>
                            <option v-for="sdepartment in departments" :key="sdepartment?.id" :value="sdepartment?.id">{{ sdepartment?.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <select v-model="scheduleInfo.main_component_id" name="main_component_id" class="form-control" @change="getComponentList(scheduleInfo.main_component_id)">
                            <option value selected>Select main component</option>
                            <option v-for="mainComponent in mainComponents" :key="mainComponent?.id" :value="mainComponent?.id">{{ mainComponent?.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <select v-model="scheduleInfo.component_id" name="component_id" class="form-control" @change="getSubComponent(scheduleInfo.component_id)">
                            <option value selected>Select component</option>
                            <option v-for="component in components" :key="component?.id" :value="component?.id">{{ component?.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <select v-model="scheduleInfo.sub_component_id" name="component_id" class="form-control" @change="getSubSubComponent(scheduleInfo.sub_component_id)">
                            <option value="0" selected>Select Sub component</option>
                            <option v-for="subcomponent in subcomponents" :key="subcomponent?.id" :value="subcomponent?.id">{{ subcomponent?.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <select v-model="scheduleInfo.sub_sub_component_id" name="component_id" class="form-control">
                            <option value="0" selected>Select Sub Sub component</option>
                            <option v-for="subsubcomponent in subsubcomponents" :key="subsubcomponent?.id" :value="subsubcomponent?.id">{{ subsubcomponent?.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3 col-6">
                      <div class="form-group">
                          <DatePicker type="date" placeholder="Date From" v-model="scheduleInfo.dateFrom" valueType="format"></DatePicker>
                        </div>
                      </div>
                      <div class="col-md-3 col-6">
                      <div class="form-group">
                          <DatePicker type="date" placeholder="Date To" v-model="scheduleInfo.dateTo" valueType="format"></DatePicker>
                        </div>
                      </div>
                      <div class="col-md-3 col-6">
                        <div class="form-group">
                          <input type="text" v-model="scheduleInfo.searchInput" placeholder="Enter Component & Job Name and Code" name="searchInput" class="form-control">
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="form-group">
                          <button class="form-control btn-info btn btn-sm" @click="getAllJobList()">Search</button>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="loading"
                      class="col-md-12 text-center"
                      style="margin-top:25%"
                    >
                      <PulseLoader
                        :loading="loading"
                      ></PulseLoader>
                    </div>
                    <div v-if="!loading" class="card-box table-responsive">
                      <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                      <TableData :jobList="jobList?.data"
                                 :currentPage="Number(jobList?.current_page)"
                                 :perPage="Number(jobList?.per_page)"
                                 :getItemRob="getItemRob" :getItemName="getItemName"/>
                      <div v-if="listMode && jobList">
                        <Pagination :pagination="jobList" :getData="getAllJobList"  />
                      </div>
                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <div style="line-height: 10px;" class="font-weight-bold">Spare Parts Consumption History List</div>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                        </div>
                        <TableData :jobList="printItems" :getItemRob="getItemRob" :getItemName="getItemName" :isPrinting="true"/>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <JobDone v-if="JobDoneStatus" :jobInfo="selectedJob" :mode="permitWorkMode" :componentName="componentName" :Schedule="scheduleData" @enableListMode="changeListMode"/>

            <!--            pagination -->


          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import {VueEditor} from 'vue2-editor'
    import auth from '../../../auth'
    import Pagination from "@/components/Pagination/Pagination.vue";
    import JobDone from '../JobDone.vue'
    import TableData from "./TableData.vue";
    import {apiPrintData, printUtil} from "@/utils/print";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import permissionsMixin from "@/mixin/permissionsMixin";


    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        name: 'spare-parts-report',
        components: {
            TableData,
            Pagination,
            VueEditor,
            JobDone,
            DatePicker,
            PulseLoader
        },
        data() {
            return {
                appName: process.env.VUE_APP_NAME,
                loading: false,
                reportList: false,
                color: '#1ABB9C',
                size: '10px',
                jobId: 25,
                selectedComponent: '',
                selectedJob: Object,
                permissions: auth.getPermissionData(),
                treeDisplayData: [],
                scheduleData: '',
                componentName: '',
                jobType: '',
                query: '',
                content: '',
                queryFiled: 'name',
                jobList: [],
                jobListWithoutPagination: [],
                jobRemarks: '',
                listMode: true,
                offset: 20,
                printItems: [],
                isPrinting: false,
                IRR: false,
                P2W: false,
                JobDoneStatus: false,
                DeferReschedule: false,
                editMode: false,
                permitWorkMode: false,
                tableEnableMode: false,
                chiefPermisionMode: false,
                vessels: null,
                departments: [],
                mainComponents: [],
                items: [],
                components: [],
                subcomponents: [],
                subsubcomponents: [],
                vessel_id: auth.getVesselId(),
                user_type: auth.getUserType(),
                form: new Form({
                    id: '',
                    name: '',
                    email: '',
                    status: 'Activate'
                }),
                pagination: {},
                currentPage: 1,
                filter: new Form({
                    dateRange: '',
                    jobType: '',
                    jobId: '',
                    vessel_id: auth.getVesselId(),
                }),
                scheduleInfo: new Form({
                    vesselId: auth.getVesselId(),
                    department_id: '',
                    main_component_id: '',
                    component_id: '',
                    sub_component_id: '0',
                    sub_sub_component_id: '0',
                    filterDate: '',
                    searchInput: '',
                    dateFrom: '',
                    dateTo: '',
                }),
                excelHeader: [],
                excelData: []
            }
        },
        mounted() {
            this.getAllJobList(1);
            this.departmentList();
            this.geItems();
            this.getVessel();
        },
        methods: {
            getVessel() {
              let params = {
                is_all: 1
              }
                this.$http.get('/api/vessel', {params})
                    .then(response => {
                        this.vessels = response.data.success.vessel
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },

            geItems() {
                let params = {
                    vessel_id: this.vessel_id,
                    is_all: 1
                };
                this.$http.get('/api/get-items', {params}).then((response) => {
                    this.items = response?.data?.success;
                }).catch((e) => {
                    console.log(e)
                })
            },
          getItemName(itemId) {
            if (this.items != null && this.items.length > 0) {
              let item =  this.items?.find(item => item.id == itemId)?.name;
              return item;
            }
            return "";

          },
          getItemRob(itemId) {
            if (this.items != null && this.items.length > 0) {
              let item =  this.items?.find(item => item.id == itemId)?.rob;
              return item;
            }
            return "";
          },

          onPerPageChange() {
            this.getAllJobList(1);
          },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList) return rows;

            dataList.forEach((job, index) => {
              const spares = job?.spare_consumed || [];

              if (spares.length === 0) {
                // If no spare consumed, still show one row
                rows.push({
                  '#': index + 1,
                  'Job Name(Code)': `${job?.job_schedules?.job?.name || ''} (${job?.job_schedules?.job?.code || ''})`,
                  'Component Name(Code)': `${job?.job_schedules?.job?.component?.name || ''} (${job?.job_schedules?.job?.component?.code || ''})`,
                  'Spares Consumed': '',
                  'Quantity': '',
                  'ROB': '',
                  'Completion Date': job?.date || '',
                  'Maintenance Type': job?.maintenance_type || '',
                  'Done By': job?.done_by_rank?.name || '',
                });
              } else {
                spares.forEach((spare, k) => {
                  rows.push({
                    '#': k === 0 ? index + 1 : '',
                    'Job Name(Code)': k === 0
                      ? `${job?.job_schedules?.job?.name || ''} (${job?.job_schedules?.job?.code || ''})`
                      : '',
                    'Component Name(Code)': k === 0
                      ? `${job?.job_schedules?.job?.component?.name || ''} (${job?.job_schedules?.job?.component?.code || ''})`
                      : '',
                    'Spares Consumed': this.getItemName(spare?.spares_consumed),
                    'Quantity': spare?.spares_qty || '',
                    'ROB': this.getItemRob(spare?.spares_consumed),
                    'Completion Date': k === 0 ? job?.date || '' : '',
                    'Maintenance Type': k === 0 ? job?.maintenance_type || '' : '',
                    'Done By': k === 0 ? job?.done_by_rank?.name || '' : '',
                  });
                });
              }
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vesselId: this.scheduleInfo.vesselId,
                department_id: this.scheduleInfo.department_id,
                main_component_id: this.scheduleInfo.main_component_id,
                component_id: this.scheduleInfo.component_id,
                sub_component_id: this.scheduleInfo.sub_component_id,
                sub_sub_component_id: this.scheduleInfo.sub_sub_component_id,
                searchInput: this.scheduleInfo.searchInput,
                date_from: this.scheduleInfo.dateFrom,
                date_to: this.scheduleInfo.dateTo,
                is_all: 1
              };

              const res = await this.$http.get('/api/filter/spare-parts-history-list', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Spare Parts Consumption History List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            getAllJobList(page = 1) {
                this.jobList = [];
                this.loading = true;
                let params = {
                    vesselId: this.scheduleInfo.vesselId,
                    department_id: this.scheduleInfo.department_id,
                    main_component_id: this.scheduleInfo.main_component_id,
                    component_id: this.scheduleInfo.component_id,
                    sub_component_id: this.scheduleInfo.sub_component_id,
                    sub_sub_component_id: this.scheduleInfo.sub_sub_component_id,
                    searchInput: this.scheduleInfo.searchInput,
                    date_from: this.scheduleInfo.dateFrom,
                    date_to: this.scheduleInfo.dateTo,
                    is_all: 0,
                    page: page,
                    offset: this.offset,
                };
                this.$http.get('/api/filter/spare-parts-history-list', {params}).then(response => {
                    this.jobList = response.data?.success;
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                    let response = e?.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {

                    }
                });
            },
            departmentList() {
              let params = {
                is_all: 1
              }
                this.$http.get('/api/filter/department/' + this.vessel_id, {params}).then((response) => {
                    this.departments = response.data.success;
                }).catch((e) => {
                    console.log(e)
                });
            },
            getMainComponent(department_id) {
                this.mainComponents = [];
                this.components = [];
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.scheduleInfo.main_component_id = '';
                this.scheduleInfo.component_id = '';
                this.scheduleInfo.sub_component_id = '0';
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (department_id !== '') {
                    this.$http.get('/api/filter/main-component/' + this.vessel_id + '/' + department_id, {params}).then((response) => {
                        this.mainComponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },

            getComponentList(main_component_id) {
                this.components = [];
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.scheduleInfo.component_id = '';
                this.scheduleInfo.sub_component_id = '0';
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (main_component_id !== '') {
                    this.$http.get('/api/filter/component/' + this.vessel_id + '/' + main_component_id, {params}).then((response) => {
                        this.components = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getSubComponent(component_id) {
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.scheduleInfo.sub_component_id = '0';
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (component_id != '0') {
                    this.$http.get('/api/filter/sub-component/' + this.vessel_id + '/' + component_id, {params}).then((response) => {
                        this.subcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getSubSubComponent(sub_component_id) {
                this.subsubcomponents = []
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (sub_component_id != '0') {
                    this.$http.get('/api/filter/sub-sub-component/' + this.vessel_id + '/' + sub_component_id, {params}).then((response) => {
                        this.subsubcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            jobDoneFunction(job) {
                if (job?.job_done_report && job?.job_done_report != null) {
                    this.permitWorkMode = true
                } else {
                    this.permitWorkMode = false
                }
                if (this.user_type <= 3 && job?.job_done_report == null) {
                    this.$snotify.warning('Job Done Report is not Submitted')
                } else {
                    this.listMode = false
                    this.IRR = false
                    this.P2W = false
                    this.JobDoneStatus = true
                    this.selectedJob = job?.job
                    this.scheduleData = job
                    this.componentName = job?.job?.component?.name
                }
            },
            //this function use for change list mode
            changeListMode() {
                this.IRR = false;
                this.P2W = false;
                this.JobDoneStatus = false;
                this.DeferReschedule = false;
                this.listMode = true;
                this.getAllJobList();
            }
        }
    }
</script>

<style scoped>
  .mx-datepicker {
    width: 100% !important;
  }

</style>
